import React from "react";
import { Divider, Chip, Paper, Card, CardContent, Avatar, Grid, Typography, Container,Fab } from '@material-ui/core';
import { SaveAlt } from '@material-ui/icons';

import { Parallax } from "react-parallax";
import { makeStyles } from '@material-ui/core/styles'
import {Technology} from './Technology'


const styles = {
    fontFamily: "sans-serif",
    textAlign: "center"
};

const image1 =
    "https://source.unsplash.com/random";

export const About = () => {
    const classes = useStyles()
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const [chipData, setChipData] = React.useState([
        { key: 0, label: 'HTML' },
        { key: 1, label: 'CSS' },
        { key: 2, label: 'Bootstrap' },
        { key: 3, label: 'Materialize' },
        { key: 4, label: 'React' },
        { key: 5, label: 'ReactStrap' },
        { key: 6, label: 'Material UI' },
        { key: 7, label: 'Firebase' },
        { key: 8, label: 'Firestore' },
        { key: 9, label: 'Redux' },
    ]);

    return (

        <div style={styles}>
            {/* <Hello name="Parallax" /> */}
            <Parallax bgImage={image1} strength={500}>
                <Container className={classes.cardGrid} maxWidth="md" disableGutters>
                    <Card>

                        <Grid container >
                            <Grid item xs={12} sm={4} md={4}>
                                <Grid container justify='center'>

                                    <Avatar
                                        className={classes.large}
                                        src="https://source.unsplash.com/random"
                                        title="Live from space album cover"
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8}>

                                <div className={classes.details}>
                                    <CardContent className={classes.content}>
                                        <Typography component="h5" variant="h5">
                                            About Me
</Typography>
                                        <Typography variant="subtitle1" color="textSecondary">
                                            Hello! I'm Brittany, a software engineer based in Boston, MA.
</Typography>
                                        <Typography variant="subtitle1" color="textSecondary">
                                            I enjoy creating things that live on the internet, whether that be websites, applications, or anything in between. My goal is to always build products that provide pixel-perfect, performant experiences.


</Typography>
                                        <Typography variant="subtitle1" color="textSecondary">
                                            Shortly after graduating from Northeastern University, I joined the engineering team at Upstatement where I work on a wide variety of interesting and meaningful projects on a daily basis.




</Typography>
                                    </CardContent>
                                    <Divider />

                                    <CardContent className={classes.content}>
                                        <Typography component="h5" variant="h5">
                                            Skills
</Typography>


                                        <Paper component="ul" className={classes.rootChip}>
                                            {chipData.map((data) => {

                                                return (
                                                    <li key={data.key}>
                                                        <Chip
                                                            label={data.label}
                                                            className={classes.chip}
                                                            variant='outlined'
                                                            // color={data.key % 2 === 0 ? 'primary' : 'secondary'}
                                                        />
                                                    </li>
                                                );
                                            })}
                                        </Paper>

                                        <div className={classes.controls}>
                                            <Fab variant="extended" onClick={handleClickOpen}>
                                                <SaveAlt className={classes.extendedIcon} />
                                                Click here for Details
                                            </Fab>


                                        </div>



                                    </CardContent>

                                </div>
                            </Grid>

                        </Grid>
                    </Card>
                </Container>
            </Parallax>
            <Technology open={open} handleClose={handleClose} />
            
        </div>
    );


}
const useStyles = makeStyles((theme) => ({
    icon: {
        marginRight: theme.spacing(2),
    },


    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
        minHeight: '100vh'
    },
    root: {
        display: 'flex',
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(3)
    },
    content: {
        flex: '1 0 auto',
        textAlign: 'left'
    },
    cover: {
        width: 151,
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        justifyContent: 'flex-end',
        marginTop:theme.spacing(3)
    },



    large: {
        width: theme.spacing(35),
        height: theme.spacing(35),
        margin: theme.spacing(3, 0)
    },
    extendedIcon: {
        margin: theme.spacing(1)
    },
    rootChip: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
    },
    chip: {
        margin: theme.spacing(0.5)
    }

}))
